export default __webpack_public_path__ + "94646c1d7332e58bd1d56e6cebd1a40e.svg";